<template>
  <div class="qrwrapper">
    <div class="qrcontainer">
      <a-spin v-if="loading" />
      <template v-else>
        <vue-qr :text="qrCodeText" :correctLevel="3" :size="170" :margin="8" :draggable="false"></vue-qr>
        <div class="qr-cover" v-if="coverLabel && coverButton">
          <label>{{coverLabel}}</label>
          <a-button type="primary" @click="$emit('refresh-qrcode')">{{coverButton}}</a-button>
        </div>
      </template>
      
    </div>
    <div class="tip-info">
      <template v-if="statusType===''">
        <img src="../../../assets/images/qrcodeLogin/scan.png" width="40">
        <div>
          <div>打开<a href="https://open.haiziwang.com/pages/mobile" target="_blank">商客合一APP</a></div>
          <div>扫一扫登录</div>
        </div>
      </template>
      <template v-if="statusType==='success'">
        <img src="../../../assets/images/qrcodeLogin/success.png" width="24" height="24">
        <div>扫码成功</div>
      </template>
      <template v-if="statusType==='warn'">
        <img src="../../../assets/images/qrcodeLogin/warn.png" width="24" height="24">
        <div>{{warnInfo}}</div>
      </template>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import { Button, Spin } from 'ant-design-vue'
export default {
  name: 'qrcode-login',
  components: {
    [VueQr.name]: VueQr,
    [Button.name]: Button,
    [Spin.name]: Spin
  },
  props: ['status', 'token', 'loading'],
  data() {
    return {
      coverLabel: '',
      coverButton: '',
      statusType: '',
      warnInfo: ''
    }
  },
  computed: {
    qrCodeText: function() {
      return `https://shop.haiziwang.com/m/open-platform-app/scan/login/${this.token}`
    }
  },
  watch: {
    status: function(newVal, oldVal) {
      // 二维码状态值
      // 211020001  二维码已过期
      // 211020002  二维码未扫描
      // 211020003  二维码已扫描
      // 211020004  取消登录
      // 211020005  二维码不合法
      // 211020006  登录失败, 请重新扫码二维码
      if (this.token !== 'error') {
        if ([211020001, 211020005].includes(+newVal)) {
          this.coverLabel = '二维码已失效'
          this.coverButton = '刷新二维码'
          this.statusType = ''
          this.warnInfo = ''
        } else {
          this.coverLabel = ''
          this.coverButton = ''
          if (+newVal === 211020002) {
            this.statusType = ''
            this.warnInfo = ''
          } else if(+newVal === 211020003) {
            this.statusType = 'success'
            this.warnInfo = ''
          } else if(+newVal === 211020004) {
            this.statusType = 'warn'
            this.warnInfo = '您已取消本次操作，可再次扫码登录'
          } else {
            this.statusType = 'warn'
            this.warnInfo = '登录失败，请重新扫码二维码'
          }
        }
      }
    },
    token: function(newVal, oldVal) {
      if (newVal === 'error') {
        this.coverLabel = '二维码生成失败'
        this.coverButton = '重新生成'
        this.statusType = ''
        this.warnInfo = ''
      }
    }
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>
  .qrwrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .qrcontainer {
    position: relative;
    border: 1px solid #E2E2E2;
    margin-top: 24px;
    width: 172px;
    height: 172px;
    display: flex;
    justify-content: center;
    align-items: center;
    .qr-cover {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      width: 170px;
      height: 170px;
      top: 0;
      background: rgba(255,255,255,0.69);
      backdrop-filter: blur(2px);
      label {
        color: #333;
        font-weight: 500;
      }
      button {
        margin-top: 12px;
        width: 108px;
        height: 28px;
      }
    }
  }
  .tip-info {
    height: 42px;
    display: flex;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 10px;
    img {
      margin-right: 8px;
    }
    a {
      margin-left: 4px;
    }
  }
</style>
